import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function DamagePaid() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const cancelled = params.get("cancelled");
  const [d, setD] = useState(null);
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sessionId) return;
    axios.get(`${BASE}/api/public/damage-pay/${sessionId}`).then((r) => {
      setD(r.data);
      if (!r.data.paid && tries < 10) setTimeout(() => setTries((t) => t + 1), 2000);
    }).catch(() => setD({ error: true }));
  }, [sessionId, tries]);
  const paid = d?.paid;
  return (
    <div className="min-h-screen bg-[#faf8f4] flex items-center justify-center px-6" data-testid="damage-paid-page">
      <div className="max-w-md w-full ns-card p-10 text-center">
        <div className="text-[11px] uppercase tracking-[0.22em] text-teal-700 mb-4">Newport Stays</div>
        {cancelled ? (
          <><XCircle className="w-10 h-10 mx-auto text-slate-400" /><h1 className="font-serif text-3xl mt-4" data-testid="damage-paid-status">Payment cancelled</h1>
            <p className="text-sm text-slate-500 mt-2">No money was taken. You can use the Pay now link in your invoice email any time.</p></>
        ) : paid ? (
          <><CheckCircle2 className="w-10 h-10 mx-auto text-emerald-600" /><h1 className="font-serif text-3xl mt-4" data-testid="damage-paid-status">Thank you — paid</h1>
            <p className="text-sm text-slate-500 mt-2">£{Number(d.amount || 0).toFixed(2)} for invoice {d.invoice_number}{d.property_name ? ` · ${d.property_name}` : ""} has been received.</p></>
        ) : d?.error ? (
          <h1 className="font-serif text-2xl" data-testid="damage-paid-status">We couldn't find this payment</h1>
        ) : (
          <><Loader2 className="w-8 h-8 mx-auto animate-spin text-teal-700" /><h1 className="font-serif text-2xl mt-4" data-testid="damage-paid-status">Confirming your payment…</h1></>
        )}
      </div>
    </div>
  );
}
